import React from 'react';
import { Tabs } from 'antd';
import DefaultModal from '../defaultModal/DefaultModal';
import useTranslation from '../../../../hooks/translation/useTranslation';
import { ReactComponent as GRLogo } from '../../../../../resources/images/svg/GRLogo.svg';
import Stepper from '../../stepper/Stepper';
import './RegisterModal.scss';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';

function RegisterModal({
  handleAlreadyRegistered,
  setLegalFormStep,
  physicalFormStep,
  legalFormStep,
  registrationType,
  setRegistrationType,
  setPhysicalFormStep,
  items,
  handleClose,
}) {
  const { trans, configInfo } = useTranslation();
  const { showRegisterModal } = useModal();
  const { width } = useWindowDimensions();

  const isGeorgia = configInfo?.countryCode === 'GE';

  return (
    <DefaultModal centered show={showRegisterModal && width >= 1024} setShow={handleClose} width="1016px">
      <div className="flex flex-col gap-14">
        <div className="flex justify-between items-center">
          <h1 className="m-0 text-4xl">{trans('registration')}</h1>
          {isGeorgia ? <GRLogo />
            : (
              <img
                src="/ticketLogos/mobileLogoArm.png"
                alt="Armenia Railway Logo"
                width={90}
                height={42}
              />
            )}
        </div>
        <div className="flex justify-between items-center">
          <div className="flex gap-11 items-center">
            <h2 className="m-0 text-xl">{trans('registration')}</h2>
            <Stepper steps={2} activeStep={registrationType === 'physical' ? physicalFormStep : legalFormStep} setActiveStep={registrationType === 'physical' ? setPhysicalFormStep : setLegalFormStep} />
          </div>

          <div className="flex flex-col gap-4 items-end">
            <h3 className="m-0 text-base">
              {trans('already_registered')}
            </h3>
            <button onClick={handleAlreadyRegistered} type="button" className="bg-transparent border-0 cursor-pointer">
              <h2 className="m-0 text-xl text-primary">{trans('authorization')}</h2>
            </button>
          </div>
        </div>
        <Tabs className="register-tabs" items={items} activeKey={registrationType} onChange={(e) => setRegistrationType(e)} />
      </div>
    </DefaultModal>

  );
}

export default RegisterModal;
